class General {
  constructor() {
    this.loadSwipeLibrary();
  }
  loadSwipeLibrary() {
    theme.utils.libraryLoader("swipe", theme.libraries.swipe, () => {
      (theme.utils.disable_prevent_scroll = !1),
        (theme.utils.disable_swipe_listener = !1);
      var e = document.querySelectorAll("input, textarea");
      e.on("focus", () => (theme.utils.disable_prevent_scroll = !0)),
        e.on("blur", () => (theme.utils.disable_prevent_scroll = !1)),
        SwipeListener(document, {
          preventScroll: ({ detail: e }) => {
            var t;
            if (!theme.utils.disable_prevent_scroll)
              return (
                (t = Math.abs(e.x[0] - e.x[1])),
                2 * Math.abs(e.y[0] - e.y[1]) < t
              );
          },
        }),
        document.addEventListener("swipe", (e) => {
          var t, i, o, r;
          theme.utils.disable_swipe_listener ||
            (({ left: t, right: i, top: o, bottom: r } = e.detail.directions),
            t && window.trigger("theme:swipe:left"),
            i && window.trigger("theme:swipe:right"),
            o && window.trigger("theme:swipe:top"),
            r && window.trigger("theme:swipe:bottom"));
        });
    });
  }
}
new General();
